import React, { useEffect, useState } from "react";
import GearSpinner from '../../../components/GearSpinner/GearSpinner';
import PurchaseOrderService from "../../../services/PurchaseOrderService/PurchaseOrderService";
import ViewPOEmailModal from "../../../components/Modals/ViewPOEmailModal";
import moment from "moment-timezone";

const POHistory = ({ active, user }) => {
    const [historyLoader, setHistoryLoader] = React.useState(true);
    const [historyData, setHistoryData] = React.useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedEmailData, setSelectedEmailData] = useState(null);
    const [showEmailModal, setShowEmailModal] = useState(false);

    useEffect(() => {
        if (!active || !user?.name) return;
        if (active) {
            getPurchaseOrdersHistory();
        }
    }, [active, user]);

    const purchaseOrderService = new PurchaseOrderService();

    if (!active) return null;

    const getPurchaseOrdersHistory = async () => {
        setHistoryLoader(true);
        purchaseOrderService.getPurchaseOrdersHistory({ user_id: user?.id, data_status: 'shared' }).then((response) => {
            if (response.data.status === 'success' && Array.isArray(response.data.result)) {
                setHistoryData(response.data.result);
            } else {
                setHistoryData([]);
            }
        }).catch((error) => {
            console.log("Error fetching quote history:", error);
            setHistoryData([]);
        }).finally(() => {
            setHistoryLoader(false);
        });
    };

    const handleOpenEmailModal = (row) => {
        setSelectedEmailData(row);
        setShowEmailModal(true);
    };

    const renderHistoryTable = () => {
        const filteredData = historyData.filter(row =>
            row.order_number?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.mail_to?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            row.cc_to?.toLowerCase().includes(searchTerm.toLowerCase())
        );

        return (
            <div className="table-responsive">
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by PO Number, Company, or Mail To..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <table className="table table-bordered techtop-purchase-order-table2 align-middle">
                    <thead>
                        <tr className="po-table-header-dark">
                            <th className="text-center">PO No</th>
                            <th className="text-center">Company</th>
                            <th className="text-center">Mail To</th>
                            <th className="text-center">CC</th>
                            <th className="text-center">Date</th>
                            <th className="text-center">Total</th>
                            <th className="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historyLoader ? (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    <GearSpinner />
                                </td>
                            </tr>
                        ) : filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center">No Data Found</td>
                            </tr>
                        ) : (
                            filteredData.map((row) => {
                                const formattedDate = row.order_date
                                    ? (moment(row.order_date, ["MM-DD-YYYY", "YYYY-MM-DD"]).isValid()
                                        ? moment(row.order_date, ["MM-DD-YYYY", "YYYY-MM-DD"]).format("MMMM DD, YYYY")
                                        : row.order_date)
                                    : '-';

                                return (
                                    <tr key={row.id} className="quote-history-row">
                                        <td className="text-center">{row.order_number || '-'}</td>
                                        <td className="text-center">{row.company_name || '-'}</td>
                                        <td className="text-center">
                                            {row.mail_to ? (
                                                <a href={`mailto:${row.mail_to}`}>{row.mail_to}</a>
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td className="text-center">
                                            {row.cc_to ? (
                                                <a href={`mailto:${row.cc_to}`}>{row.cc_to}</a>
                                            ) : (
                                                '-'
                                            )}
                                        </td>
                                        <td className="text-center">{formattedDate}</td>
                                        <td className="text-center">{row.total ? `$${row.total}` : '-'}</td>
                                        <td className="text-center">
                                            <button
                                                type="button"
                                                className="btn submit-button"
                                                onClick={() => handleOpenEmailModal(row)}
                                            >
                                                View Email
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <React.Fragment>
            <div className="container tab-pane active" id="po-history" style={{ position: 'relative' }}>
                <div className="row flex-nowrap g-0">
                    {renderHistoryTable()}
                </div>
                <ViewPOEmailModal
                    isShow={showEmailModal}
                    onClose={() => setShowEmailModal(false)}
                    emailData={selectedEmailData}
                    userId={user?.id}
                />
            </div>
        </React.Fragment>
    );
};

export default POHistory;